import { fetcher, ListResponse } from '@tlx/astro-shared';
import useSWR from 'swr';
import { APIUrls } from '@Util/urls.ts';

export type AnnualAccounts = {
    year: number;
    start: string;
    end: string;
};

export function useFetchAnnualAccounts(dateFrom: Date | null) {
    const url = getUrl(dateFrom);

    const { data } = useSWR<ListResponse<AnnualAccounts>>(url, fetcher, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return { annualAccounts: data?.values };
}

function getUrl(dateFrom: Date | null) {
    if (dateFrom === null) {
        return null;
    }

    const year: number = dateFrom.getFullYear();

    const url = new URL(APIUrls.ANNUAL_ACCOUNTS, window.location.origin);

    url.searchParams.set('fields', 'year, start, end');
    url.searchParams.set('yearFrom', year.toString());
    url.searchParams.set('yearTo', (year + 1).toString());

    return url.href;
}
